import { describeFields } from '../common/fields';
import { PermissionSchema } from './schemas';

export const PERMISSION_FIELDS = describeFields(PermissionSchema, {
  value: {},
  label: {},
  users: {},
  groups: {},
});
